import React, { useState, useEffect } from "react";
import Spinner from "../../components/Spinner";
import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const SubscribeForm = ({ status, message, onValidated }) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (status === "success") clearFields();
  }, [status]);

  const clearFields = () => {
    setEmail("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    email &&
      email.indexOf("@") > -1 &&
      onValidated({
        MERGE0: email,
      });
  };

  const handleSubscribeEvent = () => {
    eventTrack("MailChimp Subscriber", "User has subscribed to mailchimp", "Subscribers");
    eventTrackGA4("MailChimp Subscriber", "User has subscribed to mailchimp", "Subscribers");
  };

  const validateInput = (values) => {
    if (values.some((value) => value === "") || values[0].indexOf("@") === -1) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <form className="mailchimp-coming-soon" onSubmit={(e) => handleSubmit(e)}>
      <div className="subscribe-items">
        {status === "sending" ? (
          <Spinner />
        ) : (
          <>
            <p className="para-text">Get notified when we launch</p>
            <div className="email-field-btn">
              <input
                label="Email"
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                value={email}
                className="email-text-field"
                placeholder="Email Address"
                required
              />

              <input
                className="subscribe-btn"
                label="subscribe"
                value="Join Us"
                type="submit"
                onClick={handleSubscribeEvent}
                disabled={validateInput([email])}
              />
            </div>

            {status === "error" && <div className="error" dangerouslySetInnerHTML={{ __html: message }} />}
            {status === "success" && <div className="success" dangerouslySetInnerHTML={{ __html: message }} />}
          </>
        )}
      </div>
    </form>
  );
};

export default SubscribeForm;
